import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  Box,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';
import { ArrowBack, Print, Download } from '@mui/icons-material';
import StudentIdCard from '../components/StudentIdCard';
import { API_URL } from '../utils/api';

const StudentCardPrint = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const backPath = location.pathname.startsWith('/teachers') ? '/teachers' : '/students';
  const [card, setCard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login');
          return;
        }
        const res = await fetch(`${API_URL}/api/employees/${id}/card-data`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const json = await res.json();
        if (!res.ok || !json.success) {
          throw new Error(json.error || 'Gagal memuat kartu');
        }
        setCard(json.data);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id, navigate]);

  const handlePrint = () => window.print();

  const handleSaveImage = () => {
    if (!card?.qr_data_url) return;
    const a = document.createElement('a');
    a.href = card.qr_data_url;
    a.download = `kartu-${card.student_id}.png`;
    a.click();
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !card) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography color="error">{error || 'Data tidak ditemukan'}</Typography>
        <Button startIcon={<ArrowBack />} onClick={() => navigate(backPath)} sx={{ mt: 2 }}>
          Kembali
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: '#f1f5f9', minHeight: '100vh' }}>
      <Box
        className="no-print"
        sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap', justifyContent: 'center' }}
      >
        <Button variant="outlined" startIcon={<ArrowBack />} onClick={() => navigate(backPath)}>
          Kembali
        </Button>
        <Button variant="contained" startIcon={<Print />} onClick={handlePrint}>
          Cetak Kartu
        </Button>
        <Button variant="outlined" startIcon={<Download />} onClick={handleSaveImage}>
          Simpan QR
        </Button>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <StudentIdCard card={card} />
      </Box>

      <Typography
        className="no-print"
        align="center"
        variant="caption"
        color="text.secondary"
        sx={{ mt: 2, display: 'block' }}
      >
        Ukuran standar ID card · 5.5cm × 8.6cm (atur scale saat cetak)
      </Typography>

      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { background: white !important; }
        }
      `}</style>
    </Box>
  );
};

export default StudentCardPrint;
